import React, { useEffect, useState, useContext } from 'react';
import { Drawer, List, Tag, Spin } from 'antd';
import { Context } from '../context';

// Reusable per-lecture cut-videos clips viewer (used from the list rows and the project page).
export function ClipsDrawer({ projectId, open, onClose }) {
  const { getProjectClips } = useContext(Context);
  const [clipsData, setClipsData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    if (open && projectId) {
      setLoading(true);
      setClipsData(null);
      getProjectClips(projectId)
        .then((d) => { if (active) setClipsData(d); })
        .finally(() => { if (active) setLoading(false); });
    }
    return () => { active = false; };
  }, [open, projectId, getProjectClips]);

  return (
    <Drawer
      title={`Клипы лекции${clipsData?.count != null ? ` (${clipsData.count})` : ''}`}
      placement="right"
      width={900}
      open={open}
      onClose={onClose}
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>
      ) : (clipsData?.clips?.length > 0) ? (
        <List
          dataSource={clipsData.clips}
          renderItem={(clip) => {
            const dur = clip.duration_seconds != null
              ? `${Math.floor(clip.duration_seconds / 60)}:${String(Math.round(clip.duration_seconds % 60)).padStart(2, '0')}`
              : '';
            return (
              <List.Item
                key={clip.clip_id}
                actions={[<a href={clip.url} target="_blank" rel="noreferrer">Открыть клип</a>]}
              >
                <List.Item.Meta
                  title={
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                      <span>{clip.title || clip.clip_id}</span>
                      {dur && <Tag>{dur}</Tag>}
                      {clip.verified && <Tag color="green">Проверен</Tag>}
                      {clip.censored && <Tag color="red">Цензура</Tag>}
                      {clip.needs_review && <Tag color="orange">На проверке</Tag>}
                      {clip.en_status && <Tag color="blue">{clip.en_status === 'done' ? 'EN' : `EN: ${clip.en_status}`}</Tag>}
                      {clip.dubbed && <Tag color="purple">Дубляж</Tag>}
                      {clip.is_audio_only && <Tag>Аудио</Tag>}
                    </div>
                  }
                  description={
                    <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center', color: '#666', fontSize: 12 }}>
                      <span>👁 {clip.views ?? 0}</span>
                      <span>♥ {clip.likes ?? 0}</span>
                      <span>💬 {clip.comments ?? 0}</span>
                      {clip.confidence && <span>уверенность: {clip.confidence}</span>}
                      {(clip.categories || []).slice(0, 4).map((c, i) => <Tag key={i} style={{ margin: 0 }}>{c}</Tag>)}
                    </div>
                  }
                />
              </List.Item>
            );
          }}
        />
      ) : (
        <div style={{ color: '#888', textAlign: 'center', padding: 40 }}>
          У этой лекции пока нет опубликованных клипов
        </div>
      )}
    </Drawer>
  );
}
